import type { Action } from 'redux'
import {
  defaultGetParams as getParams,
  payloadAsParam
} from '../../signalr/helpers'
import type { InvokeDefinition, StreamDefinition } from '../../signalr/types'
import type { ErrorMessageContents } from '../../helpers/hub'
import { addToast } from '../toasts/actions'
import {
  type CheckoutTicketAction,
  type UncheckoutTicketAction,
  ticketCheckoutFailure,
  ticketCheckoutSuccess,
  tradeBlotterAddTrades
} from './actions'
import type { Trade, TicketChanges } from './types'

export const fetchTradeBlotterDefinition: StreamDefinition<
  [],
  Trade[],
  Action
> = {
  method: 'GetTrades',
  strategy: 'switch',
  getParams,
  mapResponse: tradeBlotterAddTrades,
  errorAction: 'tradeBlotter.fetchFail',
  cancelOn: ['tradeBlotter.fetchCancel']
}

export const confirmTradeDefinition: InvokeDefinition<[number], void, Action> =
  {
    method: 'ConfirmTrade',
    getParams: payloadAsParam
  }

const errorToast = (call: string, err: ErrorMessageContents) =>
  addToast({
    message: err.message ?? err.errorCode,
    options: { toastId: `tradeBlotter-${call}-error`, type: 'error' }
  })

export const checkoutTicketDefinition: InvokeDefinition<
  [number, TicketChanges],
  void,
  CheckoutTicketAction
> = {
  method: 'CheckoutTicket',
  getParams: (_state, action) => [
    action.payload.ticketId,
    action.payload.changes
  ],
  mapResponse: ticketCheckoutSuccess,
  mapError: (err) => [ticketCheckoutFailure(err), errorToast('checkout', err)]
}

export const uncheckoutTicketDefinition: InvokeDefinition<
  [number],
  void,
  UncheckoutTicketAction
> = {
  method: 'UncheckoutTicket',
  getParams: payloadAsParam,
  mapResponse: ticketCheckoutSuccess,
  mapError: (err) => [ticketCheckoutFailure(err), errorToast('uncheckout', err)]
}
